import { z } from 'zod';

const REQUIRED_REASON_MESSAGE = 'กรุณาระบุสาเหตุที่ยกเลิก';
const REQUIRED_REASON_MIN_LENGTH = 1;

export const CancelExamEventFormSchema = z.object({
  reason: z
    .string({ message: REQUIRED_REASON_MESSAGE })
    .trim()
    .min(REQUIRED_REASON_MIN_LENGTH, { message: REQUIRED_REASON_MESSAGE }),
});

export type CancelExamEventFormType = z.infer<typeof CancelExamEventFormSchema>;
